import { StepsActions } from "../../reducers/steps/actionsNames";

export default function (step: string) {
  return {
    step,
    type: StepsActions.NextStep,
  };
}
